import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { EmployeeDurationService } from 'src/app/shared/services/hr/employee-duration.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';

@Component({
  selector: 'app-employee-duration-data',
  templateUrl: './employee-duration-data.component.html',
  styleUrls: ['./employee-duration-data.component.scss']
})
export class EmployeeDurationDataComponent implements OnInit {
  button={}
  customDataSource: any;
  employeedropdown=[];
  
 LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
 currentLang:any;
 @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;

constructor(public Objects:ObjectsService,public _EmployeeDurationService:EmployeeDurationService,public router:Router,public gt:genericCustomStoreService) {
  // _EmployeeService.submit("Employee");    
  this.customDataSource = _EmployeeDurationService.customDataSourceEmployeeDuration;  
  this.button=Objects.button;

  gt.getdropdowndata("Employee").subscribe((res:any)=>this.employeedropdown=res)

  this.currentLang = localStorage.getItem(
    this.LOCALIZATION_LOCAL_STORAGE_KEY
  );

}
ngOnInit(): void {}

edit_add_duration(e:any){           
  this.router.navigate(['hr/add_edit_duration'])   
}
addrowfun(name:string){
  return this.gt.addrow(name)
}
}
